import { getRegion } from '@m2h/common/utils';

const CUSTOMER_SERVICE_REGION = 'HK';

export const shouldHideCustomerServiceEntry = (): boolean => (
  String(getRegion() || '').toUpperCase() !== CUSTOMER_SERVICE_REGION
);
